export default "__VITE_ASSET__9e6947da__"